import { render, staticRenderFns } from "./CheckAddress.vue?vue&type=template&id=3d072a8b&lang=pug"
import script from "./CheckAddress.vue?vue&type=script&lang=js"
export * from "./CheckAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports